import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

// Sample data for coffee sources
const coffeeSources = [
  {
    title: 'Cereals and Pulses',

    name: 'Mung Beans',
    pronunciation: 'Mung Beenz', // Standard English pronunciation
    description:
      'A highly nutritious pulse, with a mild, sweet flavor. Rich in protein and fiber, and used in a variety of dishes, including soups, stews, and sprouted salads. Important as a emerging crop within the Ethiopian agriculture sector',
    image: './assets/images/products/Mung-Beans.jpg',
  },
    {
        name: 'Teff',
        pronunciation: 'Teff', // Simplified to the name itself, as "Teff" is commonly pronounced as written in English
        description:
          "The 'Queen of Grains,' naturally gluten-free and nutrient-rich. Available in white, brown, and mixed varieties. Essential for injera, porridge, and healthy baking",
          image: './assets/images/products/teff.jpg',
      },
      
      {
        name: 'Barley',
        pronunciation: 'Bar-ley', // Standard English pronunciation
        description:
          'A robust grain, high in fiber and with a nutty flavor. Offered as whole grain, pearled, or flour. Ideal for traditional stews, soups, and hearty breads',
          image: './assets/images/products/barele.jpeg',
      },
      {
        name: 'Wheat',
        pronunciation: 'Weet', // Standard English pronunciation
        description:
          'High quality wheat, that is a staple food in Ethiopia. We provide different varieties of wheat, that is suitable for baking, and other food products',
          image: './assets/images/products/wheat.jpeg',
      },
      {
        name: 'Maize (Corn)',
        pronunciation: 'Mayz', // Standard English pronunciation for "Maize"
        description:
          'A versatile staple, available as whole kernels, flour, and grits. Used in a variety of traditional and contemporary dishes, from porridge to breads',
          image: './assets/images/products/corn.webp',
      },
      {
        name: 'Sorghum',
        pronunciation: 'Sor-gum', // Standard English pronunciation
        description:
          'A drought-resistant grain, naturally gluten-free and packed with nutrients. Available in various colors and forms, suitable for porridge, flatbreads, and brewing',
          image: './assets/images/products/sorgum.jpg',
      },
      {
        name: 'Chickpeas',
        pronunciation: 'Chik-peez', // Standard English pronunciation
        description:
          'A protein-rich pulse, with a creamy texture. Available in various sizes and colors, perfect for stews, salads, and hummus',
          image: './assets/images/products/cheakpeas.jpeg',
      },
      {
        name: 'Lentils',
        pronunciation: 'Len-tils', // Standard English pronunciation
        description:
          'A staple source of protein and fiber. Available in red, green, and brown varieties. Used in a wide range of traditional and international dishes.',
          image: './assets/images/products/linties.jpeg',
      },
      {
        name: 'Haricot Beans',
        pronunciation: 'Ha-ri-ko Beenz', // Phonetic breakdown for "Haricot"
        description:
          'A creamy and versatile bean, rich in nutrients. Ideal for stews, soups, and side dishes. Available in different sizes, and colors',
        image: './assets/images/products/Haricot Beans.webp',
      },
      {
        name: 'Fava Beans',
        pronunciation: 'Fah-vah Beenz', // Phonetic breakdown for "Fava"
        description:
          'A hearty and nutritious bean, with a distinctive flavor. Used in traditional Ethiopian dishes and international cuisine',
        image: './assets/images/products/Fava Beans.jpg',
      },
      {
        name: 'Soybeans',
        pronunciation: 'Soy-beenz', // Standard English pronunciation
        description:
          'A highly versatile and protein-rich legume. Used for oil extraction, food products (tofu, soy milk), and animal feed. A growing and important crop within the Ethiopian agriculture sector',
        image: './assets/images/products/Soybeans.jpg',
      },
  {
    title: 'Oilseeds',
    name: 'Sesame Seeds',
    pronunciation: 'Yir-ga-chef',
    description:
      "The 'Queen of Grains,' naturally gluten-free and nutrient-rich. Available in white, brown, and mixed varieties. Essential for injera, porridge, and healthy baking",
    image: './assets/images/products/Sesame Seeds.jpeg',
  },
  {
    name: 'Niger Seeds (Noug)',
    pronunciation: 'No-ug',
    description:
      'A unique oilseed with a distinct, slightly spicy flavor. Used for oil extraction and as a flavorful ingredient in traditional Ethiopian cuisine.',
    image: './assets/images/products/Niger Seeds (Noug).jpg',
  },
  {
    name: 'Flax Seeds',
    pronunciation: 'Flax-seeds',
    description:
      'A rich source of omega-3 fatty acids and fiber. Available whole or ground, for use in baking, smoothies, and as a nutritional supplement.',
    image: './assets/images/products/Flax Seeds.jpeg',
  },
  {
    name: 'Groundnuts (Peanuts)',
    pronunciation: 'Ground-nuts',
    description:
      'High quality groundnuts, that are a great source of protein. We provide groundnuts that are suitable for snacks, oil, and other food products.',
    image: './assets/images/products/Groundnuts (Peanuts).jpeg',
  },
  {
    title: 'Coffee',
    name: 'Yirgacheffe Coffee',
    pronunciation: 'Yir-ga-chef',
    description:
      'Renowned for its bright, floral, and citrus notes. Available in washed and natural processed varieties, offering a delicate and complex flavor profile.',
    image: './assets/images/products/yirgacheffee.jpeg',
  },
  {
    name: 'Sidamo Coffee',
    pronunciation: 'Si-da-mo',
    description:
      'Known for its medium body and vibrant acidity, with notes of berries, chocolate, and spices. Available in various roast levels.',
    image: './assets/images/products/sidamo.jpg',
  },
  {
    name: 'Harrar Coffee',
    pronunciation: 'Har-rar',
    description:
      'Distinctive for its bold, fruity, and wine-like flavors. Primarily natural processed, offering a rich and intense coffee experience.',
    image: './assets/images/products/Harrar.jpeg',
  },
  {
    name: 'Jimma Coffee',
    pronunciation: 'Jim-ma',
    description:
      'A wilder, earthier coffee, that has a heavier body, and lower acidity. This coffee is used in many traditional Ethiopian coffee ceremonies.',
    image: './assets/images/products/Jimma.jpeg',
  },
  {
    name: 'Limu Coffee',
    pronunciation: 'Li-mu',
    description:
      'A balanced and aromatic coffee, with notes of wine and spice. Known for its smooth, medium body and clean finish.',
    image: './assets/images/products/Limu.jpeg',
  },
  {
    title: 'Spices',
    name: 'Berbere',
    pronunciation: 'Ber-be-re',
    description:
      'The heart of Ethiopian cuisine. A complex blend of chili peppers, garlic, ginger, basil, korarima, rue, ajwain, and more. Offers a rich, warm, and slightly spicy flavor profile. Essential for stews (wats) and various traditional dishes.',
    image: './assets/images/products/Berbere.jpeg',
  },
  {
    name: 'Mitmita',
    pronunciation: 'Mit-mi-ta',
    description:
      "A fiery and intensely flavorful spice blend. Primarily composed of African bird's eye chili peppers, cardamom, cloves, and salt. Adds a powerful kick to raw meat dishes (kitfo), stews, and other culinary creations.",
    image: './assets/images/products/Mitmita.jpeg',
  },
  {
    name: 'Korarima (Ethiopian Cardamom)',
    pronunciation: 'Ko-ra-ri-ma',
    description:
      'A unique cardamom variety with a pungent, peppery, and citrusy aroma. Used in coffee ceremonies, stews, and bread. Adds a distinctive warmth and complexity to dishes.',
    image: './assets/images/products/korerima.jpg',
  },
  {
    name: 'Ginger (Zinjibil)',
    pronunciation: 'Zin-ji-bil',
    description:
      'A pungent and aromatic root, used in both savory and sweet dishes. Available in fresh and dried forms. Essential for flavoring stews, teas, and traditional beverages.',
    image: './assets/images/products/Ginger (Zinjibil).jpeg',
  },
  {
    name: 'Turmeric (Erd)',
    pronunciation: 'Erd',
    description:
      'A vibrant yellow spice, known for its earthy flavor and health benefits. Used in stews, sauces, and traditional remedies. Adds a warm, peppery note and a beautiful golden hue.',
    image: './assets/images/products/turmeric.webp',
  },
  {
    name: 'Black Cumin (Black Jeera/Kalo Azez)',
    pronunciation: 'Ka-lo A-zez',
    description:
      'A distinct variety of cumin with a smoky, nutty flavor. Used in stews, breads, and vegetable dishes. Offers a unique depth and complexity to Ethiopian cuisine.',
    image: './assets/images/products/Black Cumin.webp',
  },
  {
    name: 'Rue (Tena Adam)',
    pronunciation: 'Te-na A-dam',
    description:
      'An aromatic herb with a slightly bitter, pungent flavor. Used sparingly to add a unique dimension to stews and other traditional dishes.',
    image: './assets/images/products/Rue (Tena Adam).webp',
  },
  {
    name: 'Sacred Basil (Besobila)',
    pronunciation: 'Be-so-bi-la',
    description:
      'A fragrant herb with a minty, slightly peppery aroma. Used in stews, sauces, and traditional beverages. Adds a refreshing and aromatic note.',
    image: './assets/images/products/Sacred Basil (Besobila).jpeg',
  },
  {
    name: 'Ajwain (Netch Azmud)',
    pronunciation: 'Netch Az-mud',
    description:
      'A pungent, thyme-like spice with a slightly bitter flavor. Used in stews, breads, and vegetable dishes. Offers a distinct aroma and flavor.',
    image: './assets/images/products/Ajwain (Netch Azmud).webp',
  },
  {
    name: 'Long Pepper (Timiz)',
    pronunciation: 'Ti-miz',
    description:
      'A unique pepper, that is longer than regular pepper, and has a very strong peppery taste. Used in many Ethiopian dishes.',
    image: './assets/images/products/Long Pepper (Timiz).jpg',
  },
];

// Group products by category
const groupedProducts = coffeeSources.reduce((acc, product, index) => {
  if (product.title) {
    // Start a new category
    acc.push({
      category: product.title,
      items: [product],
    });
  } else {
    // Add to the last category
    acc[acc.length - 1].items.push(product);
  }
  return acc;
}, []);

const AllProducts = () => {
  const [activeCategory, setActiveCategory] = useState(groupedProducts[0]?.category);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    // Smooth scroll to the category section
    document.getElementById(category.replace(/\s+/g, '-').toLowerCase()).scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] overflow-hidden">
        {/* Background Image with Parallax Effect */}
        <div
          className="absolute inset-0 bg-cover bg-fixed bg-center"
          style={{ 
            backgroundImage: `url('./assets/images/others/coffee.jpg')`,
            transform: "translateZ(0)"
          }}
        ></div>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-emerald-900/60"></div>

        {/* Content */}
        <Header />
        <div className="absolute inset-0 flex items-center justify-center px-6">
          <div className="max-w-3xl text-center">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight drop-shadow-lg animate-fadeIn">
              Our Products
            </h1>
            <div className="w-24 h-1 bg-emerald-500 mx-auto mb-8"></div>
            <p className="text-xl md:text-2xl text-white font-light leading-relaxed max-w-2xl mx-auto">
              Discover the finest agricultural products from Ethiopia
            </p>
          </div>
        </div>
        
        {/* Decorative Wave Divider */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </div>

      {/* Category Navigation */}
      <div className=" top-0 z-30 bg-white py-4">
        <div className="container mx-auto px-4">
          <div className="flex overflow-x-auto pb-2 hide-scrollbar">
            {groupedProducts.map((group, index) => (
              <button
                key={index}
                onClick={() => handleCategoryClick(group.category)}
                className={`whitespace-nowrap px-6 py-2 mx-2 rounded-full transition-all duration-300 ${
                  activeCategory === group.category
                    ? 'bg-emerald-600 text-white font-medium'
                    : 'bg-gray-100 text-gray-700 hover:bg-emerald-100'
                }`}
              >
                {group.category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-80 transition-opacity duration-300">
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto transform transition-all">
            <div className="relative">
              <img 
                src={selectedProduct.image} 
                alt={selectedProduct.name} 
                className="w-full h-64 object-cover rounded-t-xl"
              />
              <button 
                onClick={closeProductModal}
                className="absolute top-4 right-4 bg-white rounded-full p-2 hover:bg-gray-100 transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-6">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">{selectedProduct.name}</h2>
              <p className="text-lg text-emerald-600 mb-4">Pronunciation: {selectedProduct.pronunciation}</p>
              <div className="w-16 h-1 bg-emerald-500 mb-6"></div>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                {selectedProduct.description}
              </p>
              <div className="flex justify-end">
                <button 
                  onClick={closeProductModal}
                  className="px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Products Display */}
      <div className="container mx-auto px-6 py-16">
        {groupedProducts.map((group, groupIndex) => (
          <div 
            key={groupIndex} 
            id={group.category.replace(/\s+/g, '-').toLowerCase()}
            className="mb-20 scroll-mt-24"
          >
            {/* Category Heading */}
            <div className="flex items-center mb-10">
              <h2 className="text-3xl font-bold text-gray-900">{group.category}</h2>
              <div className="ml-6 h-1 bg-emerald-500 flex-grow"></div>
            </div>

            {/* Grid for All Cards in This Category */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {group.items.map((product, index) => (
                <div
                  key={index}
                  onClick={() => handleProductClick(product)}
                  className="bg-white rounded-xl overflow-hidden transform hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                      <span className="inline-block px-3 py-1 bg-emerald-600 text-white text-sm rounded-full">
                        View Details
                      </span>
                    </div>
                  </div>

                  {/* Card Content */}
                  <div className="p-5">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 group-hover:text-emerald-600 transition-colors">
                      {product.name}
                    </h3>
                    <p className="text-sm text-emerald-600 mb-3 font-medium">
                      {product.pronunciation}
                    </p>
                    <p className="text-gray-600 text-sm line-clamp-3">
                      {product.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="bg-emerald-700 py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Interested in Our Products?
            </h2>
            <p className="text-emerald-100 text-lg mb-8 max-w-2xl mx-auto">
              Contact us today to learn more about our high-quality agricultural products from Ethiopia.
            </p>
            <a 
              href="/contact" 
              className="inline-block bg-white text-emerald-700 font-bold py-3 px-8 rounded-full hover:bg-emerald-50 transition-colors duration-300"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>

      <Footer/>

      {/* Custom CSS for hiding scrollbar but allowing scroll */}
      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .animate-fadeIn {
          animation: fadeIn 1.5s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default AllProducts;